import axios from "axios";
import helpers from "helpers/index";
import TypedPlan from "../../../interfaces/plan.interface";


export function getListExtension(param: object) {
  return axios.get<TypedPlan[]>(`plan/list-plan${helpers.buildEndUrl(param)}`)
}
